import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'
import Divider from '../../../../BaseComponents/Divider'

type HorizontalFormLineProps = {
    type: 'S' | 'U' | 'N'
}

const HorizontalFormLine: FunctionComponent<HorizontalFormLineProps> = ({ type }) => (
    <Grid horizontal centerVertical height={30} noExpand backgroundColor="pearl">
        <Grid width={24} noExpand>
            <SmallBodyFont bold>{type}</SmallBodyFont>
        </Grid>
        <Divider />
    </Grid>
)
export default HorizontalFormLine
